import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from './enUS/translation.json';
import zhTranslation from './zhCN/translation.json';
import frTranslation from './frFR/translation.json';
import jaTranslation from './jaJP/translation.json';
import esTranslation from './esES/translation.json';
import zhTWTranslation from './zhTW/translation.json';
import koTranslation from './koKR/translation.json';
export const resources = {
  enUS: {
    translation: enTranslation
  },
  zhCN: {
    translation: zhTranslation
  },
  frFR: {
    translation: frTranslation
  },
  jaJP: {
    translation: jaTranslation
  },
  esES: {
    translation: esTranslation
  },
  zhTW: {
    translation: zhTWTranslation
  },
  koKR: {
    translation: koTranslation
  }
};

i18next.use(initReactI18next).init({
  lng: 'enUS', // if you're using a language detector, do not define the lng option
  debug: true,
  resources
});
